<template>
  <div>
    <a-form layout="inline">
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-item label="学期">
            <a-select
              v-model="termId"
              style="width: 200px"
              placeholder="请选择"
              showSearch
              optionFilterProp="children"
            >
              <a-select-option
                :value="item.id"
                v-for="item in teaTermDoList"
                :key="item.id"
              >
                {{ item.termName }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="学校名称">
            <a-select
              v-model="schoolId"
              style="width: 200px"
              placeholder="请选择"
              showSearch
              optionFilterProp="children"
            >
              <a-select-option
                :value="item.id"
                v-for="item in schoolList"
                :key="item.id"
              >
                {{ item.schoolName }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item class="search-oper">
            <a-button style="margin-right: 10px" type="primary" @click="search"
              >查询</a-button
            >
            <a-button @click="reset">重置</a-button>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-table
            :dataSource="tableList"
            :pagination="pagination"
            @change="tableChange"
            :loading="loading"
            :columns="columns"
          >
            <span slot="action" slot-scope="text, record">
              <template>
                <a @click="examine(record)">查看</a>
              </template>
            </span>
          </a-table>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import education from '../../api/education'

const columns = [
  {
    title: '学校名称',
    dataIndex: 'schoolName',
    key: 'schoolName',
  },
  {
    title: '预开班数',
    dataIndex: 'proOpenClass',
    key: 'proOpenClass',
  },
  {
    title: '已开班数',
    dataIndex: 'openClass',
    key: 'openClass',
  },
  {
    title: '已取消班级数',
    dataIndex: 'cancelClass',
    key: 'cancelClass',
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  name: 'overview',
  data() {
    return {
      form: this.$form.createForm(this),
      columns,
      schoolList: [],
      teaTermDoList: [],
      tableList: [],
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      }, //分页数据对象
      loading: false,
      termId: '',
      schoolId: '',
    }
  },
  created() {
    this.init()

    this.getTeachingOverview()
  },
  methods: {
    //当前列查看
    examine(record) {
      console.log('examinerecord', record)

      this.$router.push({
        name: 'classList',
        params: { schoolId: record.schoolId },
      })
    },
    //重置
    reset() {
      this.termId = ''
      this.schoolId = ''
    },
    //查询
    search() {
      this.getTeachingOverview({
        termId: this.termId,
        schoolId: this.schoolId,
      })
    },
    init() {
      education.getTermAndSchoolList().then((res) => {
        console.log('getTermAndSchoolListres', res)
        this.schoolList = res.schoolList
        this.teaTermDoList = res.teaTermDoList
      })
    },
    getTeachingOverview(params) {
      this.loading = true
      education.getTeachingOverview(params).then((res) => {
        this.loading = false
        console.log('表格res', res)
        this.tableList = res.data.list
        this.pagination = res.data.pagination
      })
    },
    tableChange(pagination, filters, sorter) {
      this.pagination = pagination
      this.getTeachingOverview({
        termId: this.termId,
        schoolId: this.schoolId,
        currentPage: this.pagination.current,
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
